import React from "react";
import styled from "styled-components";
import { Navbar2 } from "../common";
import images from "../constants/images";
import { FaCheckCircle, FaEnvelope, FaSpinner } from "react-icons/fa";

const SucessPage = () => {
  return (
    <>
      <Navbar2 color="#000" logo={images.logo} />
      <Wrapper>
        <ContentContainer>
          <SuccessIcon>
            <FaCheckCircle />
          </SuccessIcon>

          <MainHeading>Thank You — Your Membership Is Active!</MainHeading>

          <Description>
            You're all set. We just emailed you your temporary password so you
            can log in for the first time.
          </Description>

          <Section>
            <SectionTitle>What happens next</SectionTitle>
            <StepsList>
              <StepItem>
                <StepNumber>1</StepNumber>
                <StepText>
                  Open the email we just sent you — your username is your email
                  address, and the message includes your temporary password.
                </StepText>
              </StepItem>
              <StepItem>
                <StepNumber>2</StepNumber>
                <StepText>
                  Use those credentials to log in to your account.
                </StepText>
              </StepItem>
              <StepItem>
                <StepNumber>3</StepNumber>
                <StepText>
                  Once you're in, you'll be prompted to update your password as
                  part of the setup process.
                </StepText>
              </StepItem>
            </StepsList>
          </Section>

          <HelpSection>
            <HelpTitle>
              <FaEnvelope style={{ marginRight: "8px" }} />
              Didn't see the email?
            </HelpTitle>
            <HelpText>
              Check Promotions or Spam — occasionally it lands there.
            </HelpText>
            <HelpText>
              If you still don't see it, just message us at{" "}
              <PhoneLink href="tel:5042916322">(504) 291-6322</PhoneLink> and
              we'll resend it.
            </HelpText>
          </HelpSection>

          <ButtonContainer>
            <PortalButton
              href="https://member.sprucemicro.com/"
              // target="_blank"
            >
              Go to Member Portal
            </PortalButton>
          </ButtonContainer>
        </ContentContainer>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.main`
  background: #000000;
  min-height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
`;

const ContentContainer = styled.section`
  max-width: 700px;
  width: 100%;
  background: #ffffff;
  border-radius: 0;
  box-shadow: none;
  border: 1px solid #e5e7eb;
  padding: 3rem 2.5rem;
  text-align: center;
  color: #212529;

  @media screen and (max-width: 768px) {
    padding: 2rem 1.5rem;
  }
`;

const SuccessIcon = styled.div`
  color: #000000;
  font-size: 4rem;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
  animation: scaleIn 0.5s ease-out;

  @keyframes scaleIn {
    from {
      transform: scale(0);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  @media screen and (max-width: 768px) {
    font-size: 3rem;
  }
`;

const MainHeading = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: #000000;
  margin-bottom: 1rem;
  line-height: 1.2;

  @media screen and (max-width: 768px) {
    font-size: 1.75rem;
  }
`;

const Description = styled.p`
  font-size: 1.1rem;
  color: #555555;
  margin-bottom: 2.5rem;
  line-height: 1.6;

  @media screen and (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 2rem;
  }
`;

const Section = styled.div`
  text-align: left;
  margin-bottom: 2rem;
  background: #f7f7f8;
  padding: 1.5rem;
  border-radius: 0;
  border-left: 4px solid #000000;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #212529;
  margin-bottom: 1.25rem;

  @media screen and (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

const StepsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const StepItem = styled.li`
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  gap: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

const StepNumber = styled.div`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  background: #000000;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.9rem;
`;

const StepText = styled.p`
  flex: 1;
  font-size: 1rem;
  color: #333333;
  line-height: 1.6;
  margin: 0;
  padding-top: 4px;

  @media screen and (max-width: 768px) {
    font-size: 0.95rem;
  }
`;

const HelpSection = styled.div`
  text-align: left;
  background: #f5f3ed;
  border: 1px solid #d1d5db;
  border-radius: 0;
  padding: 1.5rem;
  margin-bottom: 2rem;
`;

const HelpTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  color: #000000;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

const HelpText = styled.p`
  font-size: 0.95rem;
  color: #333333;
  line-height: 1.6;
  margin: 0.5rem 0;

  &:last-child {
    margin-bottom: 0;
  }
`;

const PhoneLink = styled.a`
  color: #000000;
  font-weight: 600;
  text-decoration: underline;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 2rem;
`;

const PortalButton = styled.a`
  display: inline-block;
  background: #000000;
  color: white;
  padding: 1rem 2.5rem;
  border-radius: 0;
  font-size: 1rem;
  font-weight: 500;
  text-decoration: none;
  transition: opacity 0.2s ease;
  border: 1px solid #000000;

  &:hover {
    opacity: 0.9;
  }

  @media screen and (max-width: 768px) {
    padding: 0.875rem 2rem;
    font-size: 1rem;
    width: 100%;
  }
`;

export default SucessPage;
